import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es en línea? ¿Cómo recibo el programa?',
  a: 'Sí, es un producto 100% digital. Una vez completes el pago, recibirás un correo con el acceso inmediato a los 15 módulos en formato PDF descargable, listos para leer en cualquier dispositivo (teléfono, tablet o computadora).'
}, {
  q: '¿Funciona si estoy en perimenopausia?',
  a: 'Sí, totalmente. La perimenopausia es justamente la etapa donde el cuerpo empieza a cambiar y donde más se beneficia del programa. Cuanto antes intervengas con las estrategias correctas, más suave será la transición a la menopausia.'
}, {
  q: '¿Sirve para cualquier edad?',
  a: 'Está optimizado para mujeres entre 40 y 60 años, que estén experimentando perimenopausia, menopausia o postmenopausia. Si tienes menos de 40 años pero ya tienes síntomas hormonales, también puede ayudarte.'
}, {
  q: '¿Cuánto tiempo por día necesito invertir?',
  a: 'Entre 15 y 20 minutos diarios. El programa está diseñado para mujeres ocupadas — los módulos son cortos, las recetas se hacen en menos de 10 minutos, y el plan de acción de 21 días te dice exactamente qué hacer cada día sin pensarlo.'
}, {
  q: '¿Es apto si tomo medicación hormonal o terapia de reemplazo (TRH)?',
  a: 'Sí. El programa es complementario, no sustitutivo. Las estrategias de nutrición, sueño y manejo del cortisol potencian los efectos de la TRH y ayudan a reducir efectos secundarios. Aun así, te recomendamos comentarlo con tu médico de cabecera.'
}, {
  q: '¿Tengo que comprar comida especial o suplementos caros?',
  a: 'No. Usamos alimentos reales que encuentras en cualquier supermercado del mundo. La guía de suplementos es opcional y te enseña a elegir opciones accesibles y eficaces, sin gastar fortunas en marcas innecesarias.'
}, {
  q: '¿Qué pasa si no veo resultados?',
  a: 'Tienes 30 días completos de garantía de devolución. Si después de aplicar el programa sientes que no es para ti, escríbenos y te devolvemos el 100% de tu dinero, sin preguntas ni complicaciones.'
}, {
  q: '¿En cuánto tiempo veré resultados?',
  a: 'La mayoría de mujeres sienten mejoras en energía y digestión la primera semana. Cambios visibles en abdomen, sueño y claridad mental se notan entre las semanas 2 y 4. El plan de 21 días está diseñado para construir resultados sostenibles, no rápidos y temporales.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-cream-dark" data-id="element-122">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <span className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-800 text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-125">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-126">
            Preguntas Frecuentes
          </h2>
          <p className="text-charcoal-light" data-id="element-127">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-3" data-id="element-128">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: Math.min(index * 0.05, 0.3)
          }} className="bg-cream rounded-2xl border border-sage-100 overflow-hidden" data-id="element-129">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-130">
                  <span className="font-semibold text-base md:text-lg pr-8" data-id="element-131">
                    {faq.q}
                  </span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-sage-700 text-cream' : 'bg-sage-100 text-sage-800'}`} data-id="element-132">
                    {isOpen ? <Minus size={16} data-id="element-133" /> : <Plus size={16} data-id="element-134" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-135">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-136">
                      <div className="px-6 pb-5 text-charcoal-light leading-relaxed" data-id="element-137">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}